import { gql } from 'apollo-boost'

const RESOLVE_BRAND_GATEWAY_TASK = gql`
  mutation resolveBrandGatewayTask(
    $id: ID!
    $brandData: SaveBrandGatewayTaskBrandInput
    $locationsData: [SaveBrandGatewayTaskLocationInput!]!
    $newSlaveBrandIds: [ID!]!
    $newNotSameBrandIds: [ID!]!
    $removedSlaveBrandIds: [ID!]!
    $removedNotSameBrandIds: [ID!]!
  ) {
    resolveBrandGatewayTask(
      id: $id
      brandData: $brandData
      locationsData: $locationsData
      newSlaveBrandIds: $newSlaveBrandIds
      newNotSameBrandIds: $newNotSameBrandIds
      removedSlaveBrandIds: $removedSlaveBrandIds
      removedNotSameBrandIds: $removedNotSameBrandIds
    ) {
      brandGatewayTask {
        id
        brand {
          status
          rank
        }
      }
      brandDefinitionTask {
        id
      }
      menuDefinitionTask {
        id
      }
    }
  }
`

export default RESOLVE_BRAND_GATEWAY_TASK
